import { __esmMin as e } from "../../_virtual/_rolldown/runtime.es.js";
// libs/ui-lib/src/assets/icons/arrow-right.svg?raw
var t, n = e((() => {
	t = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n  <line x1=\"5\" y1=\"12\" x2=\"19\" y2=\"12\"></line>\n  <polyline points=\"12 5 19 12 12 19\"></polyline>\n</svg>\n";
}));
n();
export { t as default, n as init_arrow_right };
